import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { memo, useCallback } from 'react';
import cx from 'classnames';
import { settingsButton, settingsButtonSelected } from './classNames';

function SettingsButtonInner(_ref) {
  var property = _ref.property,
      _ref$option = _ref.option,
      optionLabel = _ref$option.label,
      optionValue = _ref$option.value,
      value = _ref.value,
      setValue = _ref.setValue,
      children = _ref.children;
  var onClick = useCallback(function () {
    setValue(property, optionValue);
  }, [setValue, property, optionValue]);
  var isSelected = optionValue === value;
  return children({
    onClick: onClick,
    isSelected: isSelected,
    label: optionLabel,
    value: optionValue,
    className: cx(settingsButton, _defineProperty({}, settingsButtonSelected, isSelected))
  });
}

export var SettingsButton = /*#__PURE__*/memo(SettingsButtonInner);